import { DRIVE_SHARE_EMAIL_REGEX, type GoogleDrivePermission } from '@fluenceur/types';

/**
 * Builds a case-insensitive set of emails that already have permissions on
 * the Drive folder. Used by the invite modal to dedupe the checkbox list
 * and by the external emails input to skip duplicates without bothering
 * Google.
 */
export const buildSharedEmailSet = (
  permissions: GoogleDrivePermission[] | undefined
): Set<string> => {
  const set = new Set<string>();
  (permissions ?? []).forEach((p) => {
    if (!p.deleted && p.emailAddress) {
      set.add(p.emailAddress.toLowerCase());
    }
  });
  return set;
};

/**
 * Parses a free-form comma/newline separated email blob from the textarea.
 * Returns lowercased valid emails and the raw invalid tokens for error
 * reporting. Uses the shared DRIVE_SHARE_EMAIL_REGEX so backend and
 * frontend agree on what looks valid.
 */
export const parseExternalEmails = (raw: string): { valid: string[]; invalid: string[] } => {
  const parts = raw
    .split(/[,\n]/)
    .map((s) => s.trim())
    .filter(Boolean);

  const valid: string[] = [];
  const invalid: string[] = [];
  for (const part of parts) {
    if (DRIVE_SHARE_EMAIL_REGEX.test(part)) valid.push(part.toLowerCase());
    else invalid.push(part);
  }
  return { valid, invalid };
};
